// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from "./client.gen.js";
/**
 * Get webhooks
 * Get a list of webhooks or a single webhook by ID
 */
export const getV1Webhooks = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/webhooks",
        ...options,
    });
};
/**
 * Create webhook
 * Create a new webhook. In order to receive decoded data, specify a partial ABI in the filters.
 */
export const postV1Webhooks = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/webhooks",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};
/**
 * Delete webhook
 * Delete a webhook. This action cannot be undone.
 */
export const deleteV1WebhooksByWebhookId = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/webhooks/{webhook_id}",
        ...options,
    });
};
/**
 * Update webhook
 * Update a webhook.
 */
export const patchV1WebhooksByWebhookId = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/webhooks/{webhook_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};
/**
 * Test webhook
 * Test your webhook URL. This will send a test event to the webhook URL signed with an example secret 'test123'. NB! The payload does not necessarily match your webhook filters. You can however use it to test signature verification and payload format handling.
 */
export const postV1WebhooksTest = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/webhooks/test",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};
/**
 * Get events
 * Get events
 */
export const getV1Events = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/events",
        ...options,
    });
};
/**
 * Get contract events
 * Get contract events
 */
export const getV1EventsByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/events/{contractAddress}",
        ...options,
    });
};
/**
 * Get contract events with specific signature
 * Get specific contract events
 */
export const getV1EventsByContractAddressBySignature = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/events/{contractAddress}/{signature}",
        ...options,
    });
};
/**
 * Get transactions
 * Get transactions
 */
export const getV1Transactions = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/transactions",
        ...options,
    });
};
/**
 * Get contract transactions
 * Get contract transactions
 */
export const getV1TransactionsByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/transactions/{contractAddress}",
        ...options,
    });
};
/**
 * Get contract transactions with specific signature
 * Get specific contract transactions
 */
export const getV1TransactionsByContractAddressBySignature = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/transactions/{contractAddress}/{signature}",
        ...options,
    });
};
/**
 * Get token transfers by transaction
 * Get token transfers by transaction
 */
export const getV1TokensTransfersTransactionByTransactionHash = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/transfers/transaction/{transaction_hash}",
        ...options,
    });
};
/**
 * Get token transfers by contract
 * Get token transfers by contract
 */
export const getV1TokensTransfersByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/transfers/{contract_address}",
        ...options,
    });
};
/**
 * Get token transfers
 * Get token transfers
 */
export const getV1TokensTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/transfers",
        ...options,
    });
};
/**
 * Get ERC-20 balances by address
 * Get ERC-20 balances for a given address
 */
export const getV1TokensErc20ByOwnerAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/erc20/{ownerAddress}",
        ...options,
    });
};
/**
 * @deprecated
 * Get ERC-721 balances by address
 * Get ERC-721 (NFT) balances for a given address [BEING DEPRECATED IN FAVOR OF /nfts/balance]
 */
export const getV1TokensErc721ByOwnerAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/erc721/{ownerAddress}",
        ...options,
    });
};
/**
 * @deprecated
 * Get ERC-1155 balances by address
 * Get ERC-1155 (Multi Token) balances for a given address [BEING DEPRECATED IN FAVOR OF /nfts/balance]
 */
export const getV1TokensErc1155ByOwnerAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/erc1155/{ownerAddress}",
        ...options,
    });
};
/**
 * Get supported tokens for price data
 * Get supported tokens for price data
 */
export const getV1TokensPriceSupported = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/price/supported",
        ...options,
    });
};
/**
 * Get token price
 * Get price in USD for given token(s)
 */
export const getV1TokensPrice = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/price",
        ...options,
    });
};
/**
 * Token lookup
 * Look up a fungible token by symbol
 */
export const getV1TokensLookup = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/tokens/lookup",
        ...options,
    });
};
/**
 * Resolve
 * Resolve
 */
export const getV1ResolveByInput = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/resolve/{input}",
        ...options,
    });
};
/**
 * Get blocks
 * Get blocks
 */
export const getV1Blocks = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/blocks",
        ...options,
    });
};
/**
 * Get contract ABI​
 * Get contract ABI​
 */
export const getV1ContractsAbiByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/contracts/abi/{contractAddress}",
        ...options,
    });
};
/**
 * Get contract metadata​
 * Get contract metadata​
 */
export const getV1ContractsMetadataByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/contracts/metadata/{contractAddress}",
        ...options,
    });
};
/**
 * Decode logs and transactions​
 * Decode logs and transactions​
 */
export const postV1DecodeByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/decode/{contractAddress}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};
/**
 * Get NFT balances by address
 * Get NFT balances for a given address
 */
export const getV1NftsBalanceByOwnerAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/balance/{ownerAddress}",
        ...options,
    });
};
/**
 * Get collection
 * Retrieve metadata about a collection
 */
export const getV1NftsCollectionsByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/collections/{contract_address}",
        ...options,
    });
};
/**
 * Get NFTs by owner
 * Get NFTs by owner
 */
export const getV1Nfts = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts",
        ...options,
    });
};
/**
 * Get NFT owners by contract
 * Get NFT owners by contract
 */
export const getV1NftsOwnersByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/owners/{contract_address}",
        ...options,
    });
};
/**
 * Get NFT owners by token
 * Get NFT owners by token
 */
export const getV1NftsOwnersByContractAddressByTokenId = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/owners/{contract_address}/{token_id}",
        ...options,
    });
};
/**
 * Get NFT transfers
 * Get NFT transfers
 */
export const getV1NftsTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/transfers",
        ...options,
    });
};
/**
 * Get NFT transfers by transaction
 * Get NFT transfers by transaction
 */
export const getV1NftsTransfersTransactionByTransactionHash = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/transfers/transaction/{transaction_hash}",
        ...options,
    });
};
/**
 * Get NFT transfers by contract
 * Get NFT transfers by contract
 */
export const getV1NftsTransfersByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/transfers/{contract_address}",
        ...options,
    });
};
/**
 * Get NFTs by contract
 * Get NFTs by contract
 */
export const getV1NftsByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/{contract_address}",
        ...options,
    });
};
/**
 * Get NFT transfers by token
 * Get NFT transfers by token
 */
export const getV1NftsTransfersByContractAddressByTokenId = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/transfers/{contract_address}/{token_id}",
        ...options,
    });
};
/**
 * Get NFT by token ID
 * Get NFT by token ID
 */
export const getV1NftsByContractAddressByTokenId = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/{contract_address}/{token_id}",
        ...options,
    });
};
/**
 * Force refresh collection metadata
 * Force refresh collection metadata for the specified contract (across multiple chains if provided)
 */
export const getV1NftsMetadataRefreshByContractAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/metadata/refresh/{contract_address}",
        ...options,
    });
};
/**
 * Force refresh token metadata
 * Force refresh token metadata for the specified contract and token ID (across multiple chains if provided)
 */
export const getV1NftsMetadataRefreshByContractAddressByTokenId = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/nfts/metadata/refresh/{contract_address}/{token_id}",
        ...options,
    });
};
/**
 * Get wallet transactions
 * Get incoming and outgoing transactions for a wallet
 */
export const getV1WalletsByWalletAddressTransactions = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: "x-client-id",
                type: "apiKey",
            },
            {
                scheme: "bearer",
                type: "http",
            },
            {
                in: "query",
                name: "clientId",
                type: "apiKey",
            },
        ],
        url: "/v1/wallets/{wallet_address}/transactions",
        ...options,
    });
};
